import React from 'react';
import { useDefaultLandingPageStore, usePromptStore } from '@globalStore/defaultLandingPageStore';
import * as createActions from '@store/dashboards/create/actions';
import * as updateActions from '@store/dashboards/update/actions';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { selector as commonSelector } from '@store/common';
import { selectors as tabsStoreSelector } from '@store/dashboards/tabs';
import { selectors as dashboardsUIStoreSelector } from '@store/dashboards/ui';
import { dashboardListSelector } from '@store/tempDashboard/selectors';
import Prompt from './Prompt';

// Define types for Redux props
interface ReduxProps {
  tabsStore: any;
  dashboardsUIStore: any;
  appliedFilters: any;
  dashboards: any[];
  createDashboard: typeof createActions.createDashboard;
  updateDashboard: typeof updateActions.updateDashboard;
  createDashboardByDashboardType: typeof createActions.createDashboardByDashboardType;
}

/**
 * A wrapper component that provides Zustand state to the Prompt component
 */
const ZustandPromptWrapper: React.FC<ReduxProps> = (props) => {
  // Get state from Zustand stores
  const promptState = usePromptStore((state) => ({
    showPrompt: state.showPrompt,
    promptTitle: state.promptTitle,
    promptContent: state.promptContent,
    promptNeedInput: state.promptNeedInput,
    promptOkFn: state.promptOkFn,
    tmpPayload: state.tmpPayload,
  }));

  const defaultLandingPage = useDefaultLandingPageStore((state) => ({
    url: state.url,
    path: state.path,
    name: state.name,
  }));

  const promptActions = usePromptStore((state) => ({
    setShowPrompt: state.setShowPrompt,
    closePrompt: state.closePrompt,
  }));

  return React.createElement(Prompt as any, {
    ...props,
    defaultLandingPageConfig: {
      ...defaultLandingPage,
      ...promptState,
    },
    visible: promptState.showPrompt,
    title: promptState.promptTitle,
    content: promptState.promptContent,
    needInput: promptState.promptNeedInput,
    onOkFn: promptState.promptOkFn,
    hidePrompt: () => promptActions.closePrompt(),
  });
};

// Keep the Redux connection for other parts of the component
const selector = createSelector(
  commonSelector,
  tabsStoreSelector,
  dashboardsUIStoreSelector,
  dashboardListSelector,
  (common, tabsStore, dashboardsUIStore, dashboards) => ({
    tabsStore,
    dashboardsUIStore,
    appliedFilters: common.appliedFilters,
    dashboards,
  }),
);

export default connect(selector, {
  createDashboard: createActions.createDashboard,
  updateDashboard: updateActions.updateDashboard,
  createDashboardByDashboardType: createActions.createDashboardByDashboardType,
})(ZustandPromptWrapper);
